import React from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';

function Hero() {
  return (
    <div className="hero">
      <div className="hero-background">
        <div className="hero-overlay"></div>
        <div className="hero-pattern"></div>
      </div>
      <div className="hero-content">
        <div className="hero-text">
          <h1 className="hero-title">PHARMACARE PHARMACIES PRIVATE LIMITED</h1>
          <p className="hero-subtitle">We care about your health</p>
          <Link to="/about" className="hero-cta">About us?</Link>
        </div>
        <div className="hero-image">
          <img 
            src={`${process.env.PUBLIC_URL}/pharmacy-hero.jpg`} 
            alt="Pharmacare Medical Services" 
            className="hero-illustration-img"
          />
        </div>
      </div>
    </div>
  );
}

export default Hero;
